<template>
  <div>
    <div class="steps-holder">
      <div
        v-for="(step, i) in steps"
        :key="`${step}-${i}`"
        class="steps-item"
        :class="{
          'current-step': i + 1 === currentStep,
          'completed': currentStep > i + 1,
          'is-failed': step.isFailed
        }"
      >
        <button
          class="step"
          :disabled="!step.isClickable"
          @click.prevent="$emit('go-to-step', {
            step,
            index: i + 1,
          })"
        >
          <span class="step-circle">
            {{ i + 1 }}
          </span>
          <span class="step-title">
            {{ step.stepLabel }}
          </span>
        </button>
        <div class="steps-separator" />
      </div>
    </div>
    <claims-form-link class="row-claims-link" />
  </div>
</template>

<script>
import ClaimsFormLink from '@/components/ClaimsFormLink.vue';

export default {
  name: 'steps',
  components: {
    ClaimsFormLink,
  },
  inject: ['config'],
  props: {
    steps: {
      type: Array,
      required: true,
    },
  },
  computed: {
    currentStep () {
      return this.steps.findIndex(step => step.isActive) + 1;
    },
  },
};
</script>

<style lang="scss">
.steps {
  &-holder {
    display: flex;
    justify-content: center;
    padding: 16px 42px;
  }

  &-separator {
    flex-shrink: 0;
    width: calc(100% - 56px);
    height: 1px;
    margin: 0 10px;
    background-color: #d0d1d8;
  }

  &-item {
    display: flex;
    align-items: center;
    width: 100%;
    max-width: 332px;

    &:last-child {
      max-width: 36px;

      .steps-separator {
        display: none;
      }
    }

    .step {
      position: relative;

      &-circle {
        display: block;
        width: 24px;
        height: 24px;
        background-color: #818d97;
        border-radius: 50%;
        line-height: 24px;
        text-align: center;
        color: var(--v-breadcrumb-number-base, $clr-white);
        font-size: 10px;
        font-weight: 700;
      }

      &-title {
        display: block;
        position: absolute;
        left: 50%;
        top: calc(100% + 4px);
        transform: translateX(-50%);
        width: 30vw;
        padding: 0 5px;
        white-space: initial;
        font-size: 10px;
      }
    }

    &.current-step,
    &.completed {
      .step-circle {
        background-color: var(--v-breadcrumb-bg-base, var(--v-primary-base, $clr-primary));
      }

      .step-title {
        font-weight: 500;
      }
    }

    &.completed {
      .step-circle {
        font-size: 0;
        position: relative;

        &::before {
          content: '';
          display: block;
          width: 10px;
          height: 5px;
          border-style: solid;
          border-color: #fff;
          border-width: 0 0 2px 2px;
          position: absolute;
          top: 50%;
          left: 50%;
          transform: translate(-50%, -50%) rotate(-45deg);
        }
      }
    }

    &.is-failed {
      .step-circle {
        background-color: var(--v-error-base, $clr-error);
      }

      .step-title {
        color: var(--v-error-base, $clr-error);
      }
    }
  }
}

@media screen and (min-width: 450px) {
  .steps {
    &-item {
      .step {
        &-title {
          white-space: nowrap;
        }
      }
    }
  }
}

@media screen and (min-width: 768px) {
  .steps {
    &-separator {
      width: calc(100% - 76px);
      margin: 0 20px;
    }

    &-item {
      .step {
        &-circle {
          width: 36px;
          height: 36px;
          line-height: 36px;
          font-size: 16px;
        }

        &-title {
          width: initial;
          font-size: 14px;
        }
      }

      &.completed {
        .step-circle {
          &::before {
            width: 16px;
            height: 7px;
          }
        }
      }
    }
  }
}
</style>
